import { render, staticRenderFns } from "./organization-asset-group-category-form.vue?vue&type=template&id=3f48bcb2"
import script from "./organization-asset-group-category-form.vue?vue&type=script&lang=js"
export * from "./organization-asset-group-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports